import React, { lazy, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation, Navigate } from 'react-router-dom'
import MainContainer from './Containers/MainContainer/MainContainer'
import SettingsContainer from './Containers/SettingsContainer/SettingsContainer'
import IndicatorMenu from './Components/Indicators/IndicatorMenu'
import IndicatorView from './Components/Indicators/IndicatorView'
import OnboardingContainer from './Containers/Onboarding/OnboardingContainer'
import StartJourney from './Components/StartJourney/StartJourney'
import HeatMapSelector from './Components/Heatmap/heatMap'
import HeatMapAbout from './Components/Heatmap/HeatMapAbout'
import NewMeeting from './Components/MeetingScheduler/NewMeeting'
import ViewMeetingContainer from './Containers/MeetingScheduler/ViewMeetingContainner'
import ViewMeeting from './Containers/MeetingScheduler/ViewMeeting'
import RiskContainer from './Containers/Risk/RiskContainer'
import AddRisk from './Containers/Risk/AddRisk'
import DisputeRisk from './Containers/Risk/DisputeRisk'
import RiskHistory from './Containers/Risk/RiskHistory'
import ViewRiskDetailsById from './Containers/Risk/ViewRiskDetailsById'
import BoardMembers from './Containers/Governance/BoardMembers'
import ChatAndTimeline from './Components/ChatAndTimeline/ChatAndTimeline'
import GovernanceSetup from './Containers/Governance/GovernanceSetUp'
import UserList from './Containers/SettingsContainer/UserManagement/UserList'
// import Login from './Containers/Auth/Login'
import AddCompliance from './Components/Governance/AddCompliance'
// import ViewCompliances from './Components/Governance/ViewCompliances'
// import GovernanceOrgChart from './Containers/Governance/GovernanceOrgChart'
// import ComplianceContainer from './Containers/Compliance/ComplianceContainer'
import ViewComplianceUser from './Containers/Compliance/ViewComplianceUser'
import PrivateRoute from './PrivateRoute'
import RolesAnaPermissionsContainer from './Containers/SettingsContainer/UserManagement/RolesAnaPermissionsContainer'
import ViewRiskByID from './Containers/Risk/ViewRiskByID'
import IssueContainer from './Containers/IssueRegister/IssueContainer'
import AddIssue from './Containers/IssueRegister/AddIssue'
import ViewIssueById from './Containers/IssueRegister/ViewIssueById'
import IssueHistory from './Containers/IssueRegister/IssueHistory'
import RouterValidator from './RouterValidator'
import HelpCenterHome from './Containers/HelpCenter/HelpCenterHome'
import Risk from './Containers/HelpCenter/Risk'
import QuestionPage from './Containers/HelpCenter/QuestionsPage'
import RejectedRisk from './Containers/Risk/RejectedRisk'
import TransferPreview from './Containers/Governance/TransferPreview'
import TransferRaciContainer from './Containers/Compliance/TransferRaciContainer'
import * as RoutePath from './Entities/RoutePath'

import * as Features from './Entities/Features'
import { useGovernanceStore } from './Containers/Onboarding/Store/GovernanceStore'
import { bodyPreview, compliancePreview, transferBody, transferCompliance } from './Entities/CommonEntities'
import { MENU_TYPE_COMPLIANCE_SETUP, MENU_TYPE_GOVERNANCE_SETUP } from './Entities/MainContainerTypes'
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary'
import Loading from './Common/ui/Loading'

// const MainContainer = lazy(() => import('./Containers/MainContainer/MainContainer'))
// const SettingsContainer = lazy(() => import('./Containers/SettingsContainer/SettingsContainer'))
// const IndicatorMenu = lazy(() => import('./Components/Indicators/IndicatorMenu'))
// const IndicatorView = lazy(() => import('./Components/Indicators/IndicatorView'))
// const HeatMapSelector = lazy(() => import('./Components/Heatmap/heatMap'))
// const HeatMapAbout = lazy(() => import('./Components/Heatmap/HeatMapAbout'))
// const NewMeeting = lazy(() => import('./Components/MeetingScheduler/NewMeeting'))
// const ViewMeetingContainer = lazy(() => import('./Containers/MeetingScheduler/ViewMeetingContainner'))
// const ViewMeeting = lazy(() => import('./Containers/MeetingScheduler/ViewMeeting'))
// const RiskContainer = lazy(() => import('./Containers/Risk/RiskContainer'))
// const AddRisk = lazy(() => import('./Containers/Risk/AddRisk'))
// const DisputeRisk = lazy(() => import('./Containers/Risk/DisputeRisk'))
// const RiskHistory = lazy(() => import('./Containers/Risk/RiskHistory'))
// const ViewRiskDetailsById = lazy(() => import('./Containers/Risk/ViewRiskDetailsById'))
// const BoardMembers = lazy(() => import('./Containers/Governance/BoardMembers'))
// const ChatAndTimeline = lazy(() => import('./Components/ChatAndTimeline/ChatAndTimeline'))
// const GovernanceSetup = lazy(() => import('./Containers/Governance/GovernanceSetUp'))
// const UserList = lazy(() => import('./Containers/SettingsContainer/UserManagement/UserList'))
// const Login = lazy(() => import('./Containers/Auth/Login'))
// const AddCompliance = lazy(() => import('./Components/Governance/AddCompliance'))
const ViewCompliances = lazy(() => import('./Components/Governance/ViewCompliances'))
const GovernanceOrgChart = lazy(() => import('./Containers/Governance/GovernanceOrgChart'))
const ComplianceContainer = lazy(() => import('./Containers/Compliance/ComplianceContainer'))
const SelectOrganization = lazy(() => import('./Components/SelectOrganization/SelectOrganization'))
const Login = lazy(() => import('./Containers/Auth/Login'))

// const ViewComplianceUser = lazy(() => import('./Containers/Compliance/ViewComplianceUser'))
// const PrivateRoute = lazy(() => import('./PrivateRoute'))
// const RolesAnaPermissionsContainer = lazy(() => import('./Containers/SettingsContainer/UserManagement/RolesAnaPermissionsContainer'))
// const ViewRiskByID = lazy(() => import('./Containers/Risk/ViewRiskByID'))
const DashboardContainer = lazy(() => import('./Containers/Dashboard/DashboardContainer'))
const DashboardV2 = lazy(() => import('./Containers/DashboardV2/DashboardV2'))
// const IssueContainer = lazy(() => import('./Containers/IssueRegister/IssueContainer'))
// const AddIssue = lazy(() => import('./Containers/IssueRegister/AddIssue'))
// const ViewIssueById = lazy(() => import('./Containers/IssueRegister/ViewIssueById'))
// const IssueHistory = lazy(() => import('./Containers/IssueRegister/IssueHistory'))
// const RouterValidator = lazy(() => import('./RouterValidator'))
// const HelpCenterHome = lazy(() => import('./Containers/HelpCenter/HelpCenterHome'))
// const Risk = lazy(() => import('./Containers/HelpCenter/Risk'))
// const QuestionPage = lazy(() => import('./Containers/HelpCenter/QuestionsPage'))
// const RejectedRisk = lazy(() => import('./Containers/Risk/RejectedRisk'))
// const TransferPreview = lazy(() => import('./Containers/Governance/TransferPreview'))
// const TransferRaciContainer = lazy(() => import('./Containers/Compliance/TransferRaciContainer'))
const SuspenseLoader = () => {
    return <Loading isLoading={true} />
}
const Routing = () => {
    const { getFeatureNavigationMenu } = useGovernanceStore()
    const featNavigationData = useGovernanceStore((state) => state.featNavigationData)
    const orgId = localStorage.getItem('orgId')
    const userId = localStorage.getItem('userId')
    useEffect(() => {
        if (location.pathname !== '/') {
            getFeatureNavigationMenu(userId, orgId)
        }
    }, [])
    useEffect(() => {
        if (featNavigationData.length > 0) {
            localStorage.setItem('featureNavigation', JSON.stringify(featNavigationData))
        }
    }, [featNavigationData])

    const categories = ['dashboard', 'risk', 'governance', 'compliance', 'calendar', 'tools', 'settings']
    const location = useLocation();

    return (
        <Routes>
            <Route path={RoutePath.START_JOURNEY.URI} element={<StartJourney />} />
            <Route path={RoutePath.LOGIN.URI} element={<Suspense fallback={<SuspenseLoader />}><Login /></Suspense>} />
            <Route path={RoutePath.ONBOARDING.URI} element={<ErrorBoundary><OnboardingContainer /></ErrorBoundary>} />

            <Route
                path={RoutePath.SELECT_ORG.URI}
                element={
                    <Suspense fallback={<SuspenseLoader />}>
                        <ErrorBoundary>
                            <SelectOrganization />
                        </ErrorBoundary>

                    </Suspense>
                }
            />
            <Route path={RoutePath.MAIN_CONTAINER.URI} element={
                <PrivateRoute>
                    <MainContainer>
                        <ErrorBoundary>
                            <Routes>

                                <Route
                                    path={RoutePath.SETTINGS.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <SettingsContainer />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.DASHBOARD.URI + RoutePath.DASHBOARD.RISK}
                                    element={
                                        // <DashboardContainer type={'RISK'} />

                                        <Navigate to={'/GRC' + RoutePath.DASHBOARD_V2.URI} replace />
                                    }
                                />
                                <Route
                                    path={RoutePath.DASHBOARD.URI + RoutePath.DASHBOARD.COMPLIANCE}
                                    element={
                                        // <DashboardContainer type={'COMPLIANCE'} />

                                        <Navigate to={'/GRC' + RoutePath.DASHBOARD_V2.URI} replace />
                                    }
                                />
                                <Route
                                    path={RoutePath.DASHBOARD_V2.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <DashboardV2 />
                                        </Suspense>
                                    }
                                />

                                <Route
                                    path={RoutePath.SETTINGS.URI + RoutePath.INDICATORS.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <IndicatorMenu />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.SETTINGS.URI + RoutePath.INDICATORS.URI + '/:types'}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <IndicatorView />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.SETTINGS.URI + RoutePath.HEAT_MAP.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <HeatMapSelector />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.SETTINGS.URI + RoutePath.HEAT_MAP_ABOUT.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <HeatMapAbout />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.CALENDAR.URI + RoutePath.CREATE_MEETING.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <NewMeeting />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.MEETING.URI + RoutePath.CALENDAR.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewMeetingContainer />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.CALENDAR.URI + RoutePath.VIEW_MEETING.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewMeeting />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.RISK.URI + RoutePath.RISK.ADD_RISK}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <AddRisk />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.RISK.URI + RoutePath.RISK.VIEW_RISK_DETAILS}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewRiskDetailsById />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.RISK.URI + RoutePath.RISK.TYPE + RoutePath.RISK.VIEW_RISK_BY_ID}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewRiskByID />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.REJECTED.URI + RoutePath.RISK.VIEW_RISK_BY_ID}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewRiskByID />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.DISPUTE.URI + RoutePath.RISK.VIEW_RISK_BY_ID}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewRiskByID />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.HISTORY.URI + RoutePath.RISK.VIEW_RISK_BY_ID}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewRiskByID />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.REJECTED.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RejectedRisk />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.DISPUTE.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <DisputeRisk />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.HISTORY.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RiskHistory />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.RISK.URI + RoutePath.RISK.TYPE}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RiskContainer />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.ISSUE.URI + RoutePath.RISK.TYPE}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <IssueContainer />
                                        </Suspense>
                                    }
                                    key={location.pathname + location.search}

                                />
                                <Route
                                    path={RoutePath.ISSUE.URI + RoutePath.ISSUE.ADD_ISSUE}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <AddIssue />
                                        </Suspense>
                                    }
                                    key={location.pathname + location.search}

                                />
                                <Route
                                    path={RoutePath.ISSUE.HISTORY}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <IssueHistory />
                                        </Suspense>
                                    }
                                    key={location.pathname + location.search}

                                />
                                <Route
                                    path={RoutePath.ISSUE.URI + RoutePath.ISSUE.TYPE + RoutePath.ISSUE.VIEW_ISSUE_BY_ID}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewIssueById />
                                        </Suspense>
                                    }
                                    key={location.pathname + location.search}

                                />

                                {/* Governance routes */}
                                <Route
                                    path={RoutePath.GOVERNANCE.MANAGEMENT_STRUCTURE}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_MANAGEMENT_STRUCTURE}>
                                                <BoardMembers />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.GOVERNANCE.MANAGEMENT_STRUCTURE + RoutePath.GOVERNANCE.MANAGEMENT_STRUCTURE_PROFILE}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_MANAGEMENT_STRUCTURE}>
                                                <BoardMembers />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.GOVERNANCE.ORG_CHART}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_ORGCHART}>
                                                <GovernanceOrgChart />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.GOVERNANCE.USER_ORG_CHART}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_ORGCHART}>
                                                <GovernanceOrgChart />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.RISK.URI + RoutePath.CHAT_AND_TIMELINE.URI + '/:riskId'}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ChatAndTimeline />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.GOVERNANCE.COMPLIANCE + '-' + RoutePath.GOVERNANCE.SETUP}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_GOVERNANCE_SETUP}>
                                                <GovernanceSetup type={MENU_TYPE_COMPLIANCE_SETUP} />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.GOVERNANCE.URI + '-' + RoutePath.GOVERNANCE.SETUP}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_GOVERNANCE_SETUP}>
                                                <GovernanceSetup type={MENU_TYPE_GOVERNANCE_SETUP} />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.GOVERNANCE.COMPLIANCE +
                                        '-' +
                                        RoutePath.GOVERNANCE.SETUP +
                                        '/:mandateType' +
                                        '/:regulationName'
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_GOVERNANCE_SETUP}>
                                                <GovernanceSetup />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.GOVERNANCE.COMPLIANCE +
                                        '-' +
                                        RoutePath.GOVERNANCE.SETUP +
                                        '/:mandateType' +
                                        '/:regulationName' +
                                        '/:complianceName'
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewCompliances />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.SETTINGS.URI +
                                        RoutePath.USER_MANAGEMENT.URI +
                                        RoutePath.USER_LIST.URI
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_USER_MANAGEMENT}>
                                                <UserList />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.SETTINGS.URI +
                                        RoutePath.USER_MANAGEMENT.URI +
                                        RoutePath.USER_LIST.URI +
                                        RoutePath.USER_LIST.PROFILE
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_USER_MANAGEMENT}>
                                                <UserList />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.SETTINGS.URI +
                                        RoutePath.USER_MANAGEMENT.URI +
                                        RoutePath.ROLES_PERMISSION.URI
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_USER_MANAGEMENT}>
                                                <RolesAnaPermissionsContainer />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.GOVERNANCE.COMPLIANCE +
                                        RoutePath.GOVERNANCE.ADD_COMPLIANCE +
                                        '/:bodyType' +
                                        '/:regulation' +
                                        '/:regulationId' +
                                        '/:complianceId'
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <AddCompliance />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.COMPLIANCE.MANAGE_COMPLIANCE}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_COMPLIANCE}>
                                                <ComplianceContainer />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                    key={location.pathname + location.search}
                                />
                                <Route
                                    path={
                                        RoutePath.COMPLIANCE.MANAGE_COMPLIANCE +
                                        '/:mandateType' +
                                        '/:regulationName'
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <RouterValidator associatedFeatures={Features.VIEW_COMPLIANCE}>
                                                <ComplianceContainer />
                                            </RouterValidator>
                                        </Suspense>
                                    }
                                    key={location.pathname + location.search}

                                />
                                <Route
                                    path={
                                        RoutePath.GOVERNANCE.COMPLIANCE +
                                        '-' +
                                        RoutePath.GOVERNANCE.SETUP +
                                        '/:mandateType' +
                                        '/:regulationName' +
                                        '/Add compliance'
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <AddCompliance />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.GOVERNANCE.COMPLIANCE +
                                        '-' +
                                        RoutePath.GOVERNANCE.SETUP +
                                        '/:mandateType' +
                                        '/:regulationName' +
                                        '/Edit compliance'
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <AddCompliance />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={
                                        RoutePath.COMPLIANCE.MANAGE_COMPLIANCE +
                                        '/:mandateType' +
                                        '/:regulationName' +
                                        '/:complianceName'
                                    }
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <ViewComplianceUser key={location.pathname + location.search} />
                                        </Suspense>
                                    }


                                />
                                <Route
                                    path={'/:username' + RoutePath.COMPLIANCE_PREVIEW.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <TransferPreview type={compliancePreview.NAME} />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={'/:username' + RoutePath.BODY_PREVIEW.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <TransferPreview type={bodyPreview.NAME} />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.TRANSFER_COMPLIANCE.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <TransferPreview type={transferCompliance.NAME} />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.TRANSFER_BODY.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <TransferPreview type={transferBody.NAME} />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path={RoutePath.TRANSFER_COMPLIANCE.URI}
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <TransferRaciContainer />
                                        </Suspense>
                                    }
                                />
                                <Route
                                    path="/help-center"
                                    element={
                                        <Suspense fallback={<SuspenseLoader />}>
                                            <HelpCenterHome />
                                        </Suspense>
                                    }
                                />
                                {categories.map((q, idx) => (
                                    <>
                                        <Route
                                            path={`/help-center/${q}`}
                                            element={
                                                <Suspense fallback={<SuspenseLoader />}>
                                                    <Risk />
                                                </Suspense>
                                            }
                                        />
                                        <Route
                                            path={`/help-center/${q}/:question`}
                                            element={
                                                <Suspense fallback={<SuspenseLoader />}>
                                                    <QuestionPage />
                                                </Suspense>
                                            }
                                        />
                                    </>

                                ))}
                            </Routes>
                        </ErrorBoundary>

                    </MainContainer>
                </PrivateRoute>
            } />
        </Routes>
    )
}

export default Routing
